module.exports = __webpack_public_path__ + "img/whats.275542c0.svg";